
export const datagridUtils = (codelistData:any,filteOption:any)=>{
    const valueOptions= codelistData?.find((item: any) => item[filteOption]?.length > 0)[filteOption]?.map((e:any)=>{return{value:e.code_list_value_code,label:e.code_list_value}})
    return {valueOptions}
}

